module.exports = __webpack_public_path__ + "static/media/dreamerhug-logo.3a917bd2.png";